
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import {Api} from "../../utils/api"
import {Fetch} from "../../utils/storage"

export default {
name: 'CreditInfo-New',
components: {
Group,
XInput,
Selector,
XButton,
XSwitch
},

created () {
},
data () {
return {
CreditInfo:{},
sexs: ['男', '女'],
diploma: ['小学', '初中', '中专', '高中', '大专', '大学', '研究生', '博士', '博士后'],
provinces: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区', '台湾省'],
duties: ['部长','副部长','院长','副院长','局长', '副局长',  '主任', '副主任','书记','副书记','处长','副处长','科长','副科长', '科员', '主治医生', '医生', '学术研究员', '护士长', '护士', '其他'],
titles: ['副高及以上', '中级', '初级', '乡村医生', '无职称'],
committee_title: ['无任职', '顾问', '名誉主任委员', '主任委员', '副主任委员', '常务委员', '委员', '秘书长', '副秘书长', '秘书'],
}
},
methods: {
async handleSubmit() {
let _this = this
if (!_this.CreditInfo.Name ||
!_this.CreditInfo.PhoneNumber ||
!_this.CreditInfo.IDCard ||
!_this.CreditInfo.EduBackground ||
!_this.CreditInfo.ContactAddress ||
!_this.CreditInfo.Email ||
!_this.CreditInfo.ZipCode ||
!_this.CreditInfo.Sex ||
!_this.CreditInfo.Province ||
!_this.CreditInfo.CommitteeTitle ||
!_this.CreditInfo.Company ||
!_this.CreditInfo.Department ||
!_this.CreditInfo.Duty ||
!_this.CreditInfo.Title) {
_this.$vux.toast.show({
text: '必选参数不能为空',
type: 'text',
width:'3rem'
})
return
}
_this.CreditInfo.Sex = _this.CreditInfo.Sex === '男' ? 1 : 2
_this.CreditInfo.UserID = Fetch('ID')
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认学分信息无误，并创建？</span>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
await Api('CreateCreditInfo',_this.CreditInfo)
_this.$vux.toast.show({
text: '创建成功',
type: 'text',
width:'3rem'
})
_this.$router.go(-1)
}catch(err) {
_this.$vux.toast.show({
text: '添加学分信息失败',
type: 'cancel',
width:'3rem'
})
}
}
})
}
},
}
